import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../../../core/http.service';

/** HR-07: an overtime row as the list returns it. */
export interface OvertimeRow {
  id: number; employeeId: number; employeeNameAr: string; employeeNameEn: string; date: string; minutes: number; rawMinutes: number;
  kind: 'Normal' | 'WeeklyOff' | 'Holiday'; source: 'Detected' | 'Manual' | 'Requested'; status: 'Pending' | 'Approved' | 'Rejected';
  reason?: string | null; managerApprovedAt?: string | null; salaryId?: number | null; amount?: number | null;
}

export interface OvertimePolicy {
  overtimeEnabled: boolean; overtimeMinimumMinutes: number; overtimeRoundingMinutes: number; overtimeDailyCapMinutes: number;
  overtimeRatePercent: number; overtimeOffDayRatePercent: number; overtimeDaysPerMonth: number;
}

@Injectable({ providedIn: 'root' })
export class EmployeeOvertimeService {
  constructor(private http: HttpService) {}

  list(q: { status?: number | null; employeeId?: number | null; from?: string; to?: string; page?: number }): Observable<any> {
    const p = new URLSearchParams();
    if (q.status) p.set('status', String(q.status));
    if (q.employeeId) p.set('employeeId', String(q.employeeId));
    if (q.from) p.set('from', q.from);
    if (q.to) p.set('to', q.to);
    p.set('page', String(q.page || 1));
    return this.http.getData(`EmployeeOvertime?${p.toString()}`);
  }
  create(body: { employeeId: number; date: string; minutes: number; kind: number; reason: string }): Observable<any> { return this.http.postData('EmployeeOvertime', body); }
  edit(id: number, minutes: number, reason?: string | null): Observable<any> { return this.http.putData(`EmployeeOvertime/${id}`, { minutes, reason: reason || null }); }
  decide(ids: number[], approve: boolean): Observable<any> { return this.http.putData('EmployeeOvertime/UpdateStatus', { ids, status: approve ? 2 : 3 }); }
  remove(id: number): Observable<any> { return this.http.deleteData(`EmployeeOvertime/${id}`); }
  settings(): Observable<{ data: OvertimePolicy }> { return this.http.getData('EmployeeOvertime/settings'); }
  saveSettings(body: OvertimePolicy): Observable<any> { return this.http.putData('EmployeeOvertime/settings', body); }
}
